import { useState } from 'react';
import { fmt } from '../constants';
import { AdSlot, Breadcrumb, InsightBox, AffiliateCard, FaqItem, ResultItem, PageFooter } from '../components/UI';

function DateInput({ label, value, onChange }) {
  return (
    <div className="input-group">
      <div className="input-label"><span>{label}</span></div>
      <input
        type="date"
        className="date-input"
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  );
}

function ShareModal({ onClose, imageDataUrl, text, url }) {
  const [copied, setCopied] = useState(false);
  const shareFacebook = () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text)}`, '_blank', 'width=600,height=400');
  const shareTwitter = () => window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_blank', 'width=600,height=400');
  const shareWhatsApp = () => window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
  const shareCopy = () => navigator.clipboard?.writeText(text + ' ' + url).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); });
  return (
    <div className="share-modal-overlay" onClick={onClose}>
      <div className="share-modal" onClick={e => e.stopPropagation()}>
        <button className="share-modal-close" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
        <div className="share-modal-title">Share Your Result</div>
        <div className="share-modal-subtitle">Your result is ready to share</div>
        {imageDataUrl && <img className="share-modal-preview" src={imageDataUrl} alt="Your result" />}
        <div className="share-modal-buttons">
          <button className="share-btn-fb" onClick={shareFacebook}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            Facebook
          </button>
          <button className="share-btn-tw" onClick={shareTwitter}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            Twitter
          </button>
          <button className="share-btn-wa" onClick={shareWhatsApp}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.117 1.535 5.845L.057 23.571l5.902-1.548A11.95 11.95 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 0 1-5.006-1.37l-.359-.213-3.502.919.934-3.41-.234-.371A9.817 9.817 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182c5.43 0 9.818 4.388 9.818 9.818 0 5.43-4.388 9.818-9.818 9.818z"/></svg>
            WhatsApp
          </button>
          <button className="share-btn-copy" onClick={shareCopy}>
            {copied
              ? <><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg> Copied!</>
              : <><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> Copy Link</>
            }
          </button>
        </div>
      </div>
    </div>
  );
}

function buildShareImage(lines) {
  const canvas = document.createElement('canvas');
  canvas.width = 1080; canvas.height = 1080;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#1B4332'; ctx.fillRect(0, 0, 1080, 1080);
  ctx.strokeStyle = 'rgba(255,255,255,0.04)'; ctx.lineWidth = 1;
  for (let i = 0; i < 1080; i += 60) {
    ctx.beginPath(); ctx.moveTo(i, 0); ctx.lineTo(i, 1080); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(0, i); ctx.lineTo(1080, i); ctx.stroke();
  }
  ctx.fillStyle = '#D4A017'; ctx.fillRect(80, 100, 920, 6);
  let y = 200;
  lines.forEach(({ text, style, size, color }) => {
    ctx.font = `${style || 'normal'} ${size || 48}px ${style === 'bold' ? 'Georgia, serif' : 'Manrope, sans-serif'}`;
    ctx.fillStyle = color || 'white';
    ctx.fillText(text, 80, y);
    y += (size || 48) + 36;
  });
  ctx.fillStyle = 'rgba(212,160,23,0.4)'; ctx.fillRect(80, 940, 920, 2);
  ctx.font = 'bold 30px Georgia, serif'; ctx.fillStyle = '#D4A017';
  ctx.fillText('financecalculator.cc', 80, 990);
  return canvas.toDataURL('image/png');
}

export default function SavingsGrowthCalc({ currency }) {
  const today = new Date().toISOString().split('T')[0];
  const [startDate, setStartDate] = useState('2003-01-01');
  const [endDate, setEndDate] = useState(today);
  const [monthly, setMonthly] = useState(60);
  const [rate, setRate] = useState(2);
  const [initial, setInitial] = useState(0);
  const [shareOpen, setShareOpen] = useState(false);
  const [imgData, setImgData] = useState(null);

  // Calculate months between dates
  const start = startDate ? new Date(startDate + 'T12:00:00') : new Date();
  const end = endDate ? new Date(endDate + 'T12:00:00') : new Date();
  const totalMonths = Math.max(0, (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth()));
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  // Compound interest calculation (monthly compounding)
  const r = rate / 100 / 12;
  const fv = totalMonths === 0
    ? initial
    : initial * Math.pow(1 + r, totalMonths) + (r === 0 ? monthly * totalMonths : monthly * (Math.pow(1 + r, totalMonths) - 1) / r);

  const totalContributed = initial + monthly * totalMonths;
  const interestEarned = fv - totalContributed;
  const growthPct = totalContributed > 0 ? ((interestEarned / totalContributed) * 100).toFixed(1) : 0;

  const timeStr = years > 0
    ? `${years} year${years !== 1 ? 's' : ''}${months > 0 ? `, ${months} month${months !== 1 ? 's' : ''}` : ''}`
    : `${months} month${months !== 1 ? 's' : ''}`;

  const insight = interestEarned > 0
    ? `Over ${timeStr}, your ${fmt(monthly, currency)}/month contributions grew into ${fmt(fv, currency)}. Of that, ${fmt(totalContributed, currency)} came from your own pocket — the rest (${fmt(interestEarned, currency)}) was pure compound interest working quietly in the background. That's a ${growthPct}% bonus on top of what you put in.`
    : `Enter a start date before today and a monthly contribution to see how your savings would have grown over time.`;

  const shareText = `I just calculated how much ${fmt(monthly, currency)}/month at ${rate}% interest grows over ${timeStr}. The result is surprising.`;
  const shareUrl = 'https://financecalculator.cc/savings-growth';

  const handleShare = () => {
    setImgData(buildShareImage([
      { text: 'Savings Growth', style: 'bold', size: 52, color: '#D4A017' },
      { text: `${fmt(monthly, currency)}/month at ${rate}% for ${timeStr}`, size: 36, color: 'rgba(255,255,255,0.65)' },
      { text: 'grew into', size: 36, color: 'rgba(255,255,255,0.5)' },
      { text: fmt(fv, currency), style: 'bold', size: 80, color: 'white' },
      { text: `of which ${fmt(interestEarned, currency)} is interest`, size: 36, color: '#52b788' },
      { text: 'Compound interest is powerful.', size: 32, color: 'rgba(255,255,255,0.45)' },
    ]));
    setShareOpen(true);
  };

  // Yearly milestones
  const milestoneYears = [1, 5, 10, 20, 30].filter(y => y * 12 <= totalMonths);
  const milestones = milestoneYears.map(y => {
    const m = y * 12;
    const val = initial * Math.pow(1 + r, m) + (r === 0 ? monthly * m : monthly * (Math.pow(1 + r, m) - 1) / r);
    return { label: `${y} year${y !== 1 ? 's' : ''}`, value: val };
  });

  return (
    <div>
      {shareOpen && <ShareModal onClose={() => setShareOpen(false)} imageDataUrl={imgData} text={shareText} url={shareUrl} />}
      <div className="calc-page">
        <Breadcrumb label="Savings Growth Calculator" />
        <h1 className="calc-page-title">How Much Have My Savings Grown?</h1>
        <p className="calc-page-desc">Enter a start date, end date, monthly amount and interest rate — and see exactly how much compound interest has added over time.</p>
        <AdSlot />
        <div className="calculator-box">
          <div className="calc-inputs">
            <DateInput label="Start Date" value={startDate} onChange={setStartDate} />
            <DateInput label="End Date" value={endDate} onChange={setEndDate} />
            <div className="input-group">
              <div className="input-label"><span>Monthly Contribution</span></div>
              <div className="number-input-wrap">
                <span className="number-input-prefix">$</span>
                <input
                  type="number"
                  className="number-input"
                  value={monthly}
                  min={0}
                  onChange={e => setMonthly(Math.max(0, Number(e.target.value)))}
                />
              </div>
            </div>
            <div className="input-group">
              <div className="input-label"><span>Annual Interest Rate</span></div>
              <div className="number-input-wrap">
                <input
                  type="number"
                  className="number-input"
                  value={rate}
                  min={0}
                  max={30}
                  step={0.1}
                  onChange={e => setRate(Math.max(0, Number(e.target.value)))}
                />
                <span className="number-input-suffix">%</span>
              </div>
            </div>
            <div className="input-group">
              <div className="input-label"><span>Initial Deposit (optional)</span></div>
              <div className="number-input-wrap">
                <span className="number-input-prefix">$</span>
                <input
                  type="number"
                  className="number-input"
                  value={initial}
                  min={0}
                  onChange={e => setInitial(Math.max(0, Number(e.target.value)))}
                />
              </div>
            </div>
          </div>
          <div className="calc-results">
            <div className="result-headline">Total Balance After {timeStr}</div>
            <div className="result-big">{fmt(fv, currency)}</div>
            <div className="result-sub">from {startDate ? new Date(startDate + 'T12:00:00').toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) : '—'} to {endDate ? new Date(endDate + 'T12:00:00').toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) : '—'}</div>
            <div className="result-grid">
              <ResultItem label="Total You Contributed" value={fmt(totalContributed, currency)} />
              <ResultItem label="Interest Earned" value={fmt(interestEarned, currency)} variant="good" />
              <ResultItem label="Growth Bonus" value={`+${growthPct}%`} variant="good" />
              <ResultItem label="Duration" value={timeStr} />
            </div>
            {milestones.length > 0 && (
              <div style={{ marginTop: 20 }}>
                <div style={{ fontSize: '0.82rem', fontWeight: 600, marginBottom: 12, color: 'var(--muted)' }}>Growth Milestones</div>
                <div className="milestones">
                  {milestones.map((m, i) => (
                    <div key={i} className="milestone">
                      <div className="milestone-dot" style={{ background: 'var(--green)' }} />
                      <div className="milestone-label">After {m.label}</div>
                      <div className="milestone-value">{fmt(m.value, currency)}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        <InsightBox text={insight} />
        <div className="share-section">
          <div className="share-title">Share Your Result</div>
          <div className="share-subtitle">Show someone what consistent saving looks like over time</div>
          <button className="share-trigger-btn" onClick={handleShare}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
            Share Your Result
          </button>
        </div>
        <AdSlot />
        <div className="affiliate-section">
          <div className="affiliate-title">Put Your Savings to Work</div>
          <div className="affiliate-cards">
            <AffiliateCard name="Barclays Online Savings" desc="Earn a competitive rate on your savings with no minimum balance and no monthly fees" cta="Open Account" href="http://www.banking.barclaysus.com/online-savings.html" />
            <AffiliateCard name="Northwestern Mutual" desc="Get a personalized savings and investment plan to grow your money faster" cta="Get Started" href="https://www.northwesternmutual.com/get-started/investments" />
          </div>
        </div>
        <div className="faq-section">
          <div className="faq-title">Common Questions</div>
          <FaqItem q="How does compound interest work?" a="Compound interest means you earn interest on your interest. Each month, your interest is added to your balance, and next month you earn interest on that larger amount. Over decades, this creates exponential growth — which is why starting early matters so much more than the amount." />
          <FaqItem q="What interest rate should I use?" a="For a regular savings account, use 2–5%. For a high-yield savings account, 4–5%. For a diversified investment portfolio (stocks/bonds), historical averages suggest 6–8% after inflation. Be conservative in your estimates." />
          <FaqItem q="Why is my interest earned so small compared to contributions?" a="At low interest rates (1–3%), compound interest takes many years to become significant. At 2% over 10 years, interest adds roughly 11% to your total. At 7% over 30 years, it more than quadruples your money. Time and rate both matter enormously." />
          <FaqItem q="Does the start date matter?" a="Yes — every year you delay costs you compounding. Starting 5 years earlier at the same monthly amount can result in significantly more money at the end, because those early contributions have more time to compound." />
        </div>
      </div>
      <PageFooter />
    </div>
  );
}
